

















































































import Country from "@/store/entities/country";
import { Component, Vue } from "vue-property-decorator";
import AddCountry from "./modals/addCountry.vue";

@Component({
  components: { AddCountry },
})
export default class Countries extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  countries: Country[] = [];

  created() {
    this.getCountries();

    (this.headers = [
      { text: "Ülke İsmi", value: "name" },
      { text: "İşlemler", value: "transactions" },
    ]),
      (this.mockData = [
        {
          name: "REDWINGS",
        },
      ]);

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Tanımlamalar", disabled: true },
      { text: "Ülkeler", disabled: true },
    ];
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getCountries() {
    await this.$store.dispatch({
      type: "country/getCountries",
    });

    this.countries = this.$store.state.country.list;
  }

  editAirlineCompany(item) {
    this.$store.state.country.editCountry = item;
    this.isOpenModal = true;
  }

  openModal() {
    this.$store.state.country.editCountry = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getCountries();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
